import { ReactComponent as Logo } from '../../../../assets/icons/header/gt-header-logo.svg';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Logout } from './components';
import { Row, Col } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useComponentVisibility } from 'hooks/useComponentVisibility';
import { useNavigate } from 'react-router-dom';
import { startNew } from '../../../../store/forms/actions';

import { getSystemLocales } from 'store/forms/actions';

const HeaderGB = props => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const showHeader = useComponentVisibility('userProfileIcon');
  const [showProfileIcon, setShowProfileIcon] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const fundingPage = location.pathname === '/fundingPage';
  const plansPage = location.pathname === '/plansPage';
  const subscriptionsPage = location.pathname === '/subscriptionsPage';

  useEffect(() => {
    setShowProfileIcon(showHeader);
  }, [showHeader]);

  const handleSubmitNew = async () => {
    try {
      const id = await dispatch(startNew());
      navigate(`/main-forms/${id}`);
    } catch (error) {
      console.error('Failed to start new form:', error);
    }
  };

  const handleSubmitNewViewForm = async () => {
    try {
      navigate(`/viewForm/1`);
    } catch (error) {
      console.error('Failed to start new form:', error);
    }
  };

  const handleViewAppTrack = async () => {
    try {
      navigate(`/appTrack/`);
    } catch (error) {
      console.error('Failed to start new form:', error);
    }
  };

  // Retrieve language from localStorage or use default
  useEffect(() => {
    const storedLanguage =
      localStorage.getItem('appLanguage') ||
      process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
    dispatch(getSystemLocales(storedLanguage));
    localStorage.setItem('appLanguage', storedLanguage);
  }, [dispatch]);

  const dummyUser = {};

  return (
    <div id="header-container">
      {/* <div id="header-content" className='main-container'> */}
      <div className="headerGB">
        <Col span={12}>
          <div className="header-icons-left">
            <Link to="/loginAs">
              <Logo />
            </Link>
          </div>
        </Col>
        {showProfileIcon && (
          <Col span={12}>
            <div className="header-icons-right">
              <button
                className={fundingPage ? 'header-tabs active' : 'header-tabs'}
                onClick={() => navigate('/fundingPage')}
              >
                <span>My Funding</span>
              </button>
              <button
                className={
                  subscriptionsPage ? 'header-tabs active' : 'header-tabs'
                }
                onClick={() => handleViewAppTrack()}
              >
                <span>My Plans</span>
              </button>
              <Logout user={user} />
            </div>
          </Col>
        )}
      </div>
    </div>
    // </div>
  );
};

export default HeaderGB;
